// extracted by mini-css-extract-plugin
export default {"btn":"scanner_btn__M-GRM","ts":"scanner_ts__C2AGH","fullWidth":"scanner_fullWidth__+lxnz"};